import Form from "../form"

class FormManager {

	constructor(parent) {
		this.app = parent
		this._init()
	}

	_init() {
		this.runDelayForm()
		this.runOneSubmitForm()
		this.runCharacterCounter()
		this.hideShowOptionalInput()
	}

	// #region Delay Form
	runDelayForm() {
		document.querySelectorAll('form[data-action]').forEach(function (el) {
			setTimeout(function() {
				el.setAttribute('action', el.dataset.action)
				el.classList.add('active')
			}, 1000)
		})
	}
	// #endregion


	// #region Once Submit Form
	runOneSubmitForm() {
		document.querySelectorAll('form[data-one-submit]').forEach((el) => {
			el.addEventListener('submit', (ev) => {
				ev.preventDefault()
				el.classList.remove('active')
				el.classList.add('loading')
				el.querySelectorAll('input').forEach(function(el) {
					el.readOnly = true
				})
				if (this.validateForm() || el.dataset.hasOwnProperty('ignoreValidator')) {
					setTimeout(() => {
						el.submit()
					}, 500)
				} else {
					el.querySelectorAll('input').forEach(function(el) {
						el.readOnly = false
					})
					this.app.pageLoadAnimation.toggleLoading(false)
				}
			})
		})
	}

	validateForm() {
		return [...document.querySelectorAll('[data-product-option]')]
			.map(el => {
				let validEl = el.querySelector('[data-product-option-validate-required]')

				if (!validEl) {
					return true
				}

				let message = validEl.dataset.productOptionValidateRequired
				let valid = (validEl.value.trim()).length > 0

				if (el.querySelector('[data-field-error]'))
					el.removeChild(el.querySelector('[data-field-error]'))

				if ((el.dataset.productOption === 'required' && !valid) || (el.dataset.productOption === 'optional' && el.querySelector('[data-option-yes]') && el.querySelector('[data-option-yes]').checked && !valid)) {
					el.classList.add('product_options_inputs--has-error')
					el.insertAdjacentHTML('beforeend', ['<p class="product_options_inputs__error-message" data-field-error>', message,'</p>'].join(''))
					return false
				}

				validEl = el.querySelector('[data-product-option-validate-two-words]')

				if (!validEl) {
					return true
				}

				message = validEl.dataset.productOptionValidateTwoWords
				valid = (validEl.value.trim().split(' ')).length <= 2

				if (el.querySelector('[data-field-error]'))
					el.removeChild(el.querySelector('[data-field-error]'))

				if ((el.dataset.productOption === 'required' && !valid) || (el.dataset.productOption === 'optional' && el.querySelector('[data-option-yes]') && el.querySelector('[data-option-yes]').checked && !valid)) {
					el.classList.add('product_options_inputs--has-error')
					el.insertAdjacentHTML('beforeend', ['<p class="product_options_inputs__error-message" data-field-error>', message,'</p>'].join(''))
					return false
				}

				el.classList.remove('product_options_inputs--has-error')
				return true
			})
			.reduce((acc, currValue) => (acc & currValue) === 1, true)
	}

	hideShowOptionalInput() {
		document.querySelectorAll('[data-product-option=optional]').forEach(el => {
			const selfEls = el.querySelectorAll('[data-options]')

			if (selfEls.length === 0)
				return

			selfEls.forEach(selfEl => {
				selfEl.addEventListener('change', (ev) => {
					if ('optionYes' in selfEl.dataset && selfEl.checked) {
						el.classList.add('product_options_inputs--show-input')
					} else {
						el.classList.remove('product_options_inputs--show-input')
						el.classList.remove('product_options_inputs--has-error')
						el.removeChild(el.querySelector('[data-field-error]'))
					}
				})
			});
		})
	}

	// #endregion

	//#region Form with Character Counters
	runCharacterCounter() {
		document.querySelectorAll('form[data-character-counter]').forEach((el) => {
			el.querySelectorAll('[data-counter]').forEach(elCounter => {
				if(elCounter.nextElementSibling.hasAttribute('data-counter-info')){
					const infoPrevMessage = elCounter.nextElementSibling.innerText
					const maxLength = elCounter.getAttribute('maxlength')
					elCounter.addEventListener('input', () => this.onInput(elCounter, maxLength, infoPrevMessage))
					elCounter.dispatchEvent(new Event('input'))
				}
			})
		})
	}
	onInput(el, maxLength, message) {
		el.nextElementSibling.innerText = el.value.length + " / " + maxLength + " " + message
	}
	// #endregion
}

export default FormManager